import { useEffect, useRef } from "react";
import { useLanguage } from "../../contexts/LanguageContext.jsx";
import { useAuth } from "../../hooks/useAuth.js";
import API from "../../config/api.js";

/**
 * Quand l'utilisateur se connecte : sauvegarde la langue actuelle dans son profil.
 * Ne remplace JAMAIS la langue choisie par l'utilisateur - elle reste partout.
 */
export default function AuthLanguageSync() {
  const { user, token } = useAuth();
  const { language } = useLanguage();
  const lastSyncedUser = useRef(null);

  useEffect(() => {
    if (!user || !token || !["fr", "en", "km"].includes(language)) return;
    if (lastSyncedUser.current === user.id) return;
    lastSyncedUser.current = user.id;

    fetch(`${API.baseURL}/users/profile/preferred-language`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ preferred_language: language }),
    }).catch(() => {});
  }, [user?.id, token, language]);

  return null;
}
